import React, {useReducer} from 'react';
import * as R from 'ramda';

import {blank} from '@/util';
import {setupCSRFToken} from '@/api';
import useAPI from '@/hooks/useAPI';
import * as api from '@/apis/index';

const handlers = {
  me: (state, action) => R.prop('payload', action),
};

const reducer = (state, action) =>
  R.tap(
    ({csrfToken}) => setupCSRFToken(csrfToken),
    R.propOr(R.identity, action.type, handlers)(state, action)
  );

const userCtx = React.createContext({});
const userDispatchCtx = React.createContext(null);

const UserProvider = ({children}) => {
  const [state, dispatch] = useReducer(reducer);
  const {result} = useAPI(api.me);

  if (blank(result)) {
    return null;
  }
  if (blank(state)) {
    dispatch({type: 'me', payload: result.data});
  } // prevent dispatch every render.

  return (
    <userDispatchCtx.Provider value={dispatch}>
      <userCtx.Provider value={state}>{children}</userCtx.Provider>
    </userDispatchCtx.Provider>
  );
};

export {userCtx, userDispatchCtx, UserProvider};
